<div class="grid grid-cols-12 items-start">
  <div class="col-span-12 2xl:col-span-9 px-3 3xl:px-0">

    <div class="bg-white border border-gray-200 rounded-2xl p-3 w-full">
      <div class="grid grid-cols-9 gap-4 items-start">

        <!-- LEFT BUTTONS (col-span-1) -->
        <div class="hidden md:flex flex-col col-span-1 items-center">
          <span class="block">
            <button mat-icon-button class="manage-post-btn my-2" (click)="backToPrevPage()" matTooltip="Back"
              aria-label="Back">
              <mat-icon svgIcon="back"></mat-icon>
            </button>
          </span>
          <span *ngIf="enableDelete === 1" class="block">
            <button mat-icon-button class="manage-post-btn my-2" (click)="openDeleteConfirm()"
              [disabled]="isDeleteDisabled" matTooltip="Delete" matTooltipPosition="left">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>

          <div class="my-4"></div>

          <span class="block">
            <button mat-icon-button class="manage-post-btn my-2" (click)="prevPost()" [disabled]="prevId === null"
              matTooltip="Previous" [matTooltipDisabled]="prevId === null">
              <mat-icon>skip_previous</mat-icon>
            </button>
          </span>

          <span class="block">
            <button mat-icon-button class="manage-post-btn my-2" (click)="nextPost()" [disabled]="nextId === null"
              matTooltip="Next" [matTooltipDisabled]="nextId === null">
              <mat-icon>skip_next</mat-icon>
            </button>
          </span>
        </div>

        <div class="col-span-9 md:col-span-8">

          <div class="w-full rounded-3xl bg-white p-4 sm:p-6">
            <!-- FORM -->
            <form [formGroup]="reuseForm" (ngSubmit)="submit()" class="relative p-10 bg-white w-full max-w-4xl mx-auto">

              <div class="mb-10 text-center">
                <h1 class="text-3xl font-bold text-gray-800 tracking-tight">
                  Reuse Post
                </h1>
              </div>


              <div class="grid grid-cols-1 md:grid-cols-2">
                <!-- Left column -->
                <div class="pr-4">
                  <div class="mb-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🌐 Choose Social Page/Site</label>
                    <select formControlName="site" [ngStyle]="{
                      'background-color': reuseForm.get('site')?.disabled ? '#e5e7eb' : '',
                      'color': reuseForm.get('site')?.disabled ? '#9ca3af' : ''
                    }"
                      class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                      <option value="">Choose Site</option>
                      <option *ngFor="let s of sites" [value]="s.Domain">{{ s.Domain }}</option>
                    </select>
                  </div>

                  <div *ngIf="feeds.length > 0" class="mb-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📂 Post Category</label>
                    <select formControlName="rss_feed_id" [ngStyle]="{
                      'background-color': reuseForm.get('rss_feed_id')?.disabled ? '#e5e7eb' : '',
                      'color': reuseForm.get('rss_feed_id')?.disabled ? '#9ca3af' : ''
                    }"
                      class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                      <option value="" disabled>Select a Category</option>
                      <option *ngFor="let f of feeds" [value]="f.id">{{ f.feed }}</option>
                    </select>
                  </div>

                  <div *ngIf="reuseForm.get('rss_feed_id')?.value && filteredPlatforms.length > 0" class="mb-6">
                    <label class="block text-sm font-semibold text-gray-700">📱 Choose Platform</label>
                    <div class="flex flex-wrap -mx-2">
                      <label *ngFor="let p of filteredPlatforms" [ngStyle]="{
                        'background-color': reuseForm.get('platform')?.disabled ? '#e5e7eb' : '',
                        'color': reuseForm.get('platform')?.disabled ? '#9ca3af' : ''
                      }"
                        class="m-2 cursor-pointer flex items-center p-4 bg-gray-50 rounded-xl border border-gray-200 hover:border-blue-500 hover:shadow-md">
                        <input type="radio" formControlName="platform" [value]="p.platform"
                          class="text-blue-600 focus:ring-blue-500" />
                        <span class="ml-3 text-sm font-medium text-gray-700">
                          {{ p.platform }}
                          <span class="block text-xs text-gray-400 mt-0.5">{{ p.domain }}</span>
                        </span>
                      </label>
                    </div>
                  </div>

                  <div *ngIf="filteredTags.length > 0" class="mb-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🏷️ Choose Format</label>
                    <select formControlName="tag"
                      class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                      <option value="" disabled>Select a tag</option>
                      <option *ngFor="let displayTag of getDisplayTagsForPlatform(filteredTags)"
                        [value]="displayTagMap[displayTag]">
                        {{ displayTag }}
                      </option>
                    </select>

                    <div *ngIf="reuseForm.get('tag')?.invalid && reuseForm.get('tag')?.touched"
                      class="mt-1 text-xs text-red-500">
                      Please select a tag.
                    </div>
                  </div>


                  <!-- ===================== -->
                  <!-- VIDEO SECTION -->
                  <!-- ===================== -->
               <ng-container *ngIf="allVideoTags.includes(reuseForm.get('tag')?.value)">

                    <!-- VIDEO TYPE -->
                    <div class="mb-6">
                      <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🎬 Video Type
                      </label>

                      <select formControlName="video_type" class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                        text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                        text-sm shadow-sm transition-colors">

                        <option value="video_upload">
                          Upload A Video
                        </option>

                        <option value="video_url" [hidden]="
                          reuseForm.get('platform')?.value === 'Instagram' ||
                          videoStoryTags.includes(reuseForm.get('tag')?.value)
                        ">
                          YouTube Link
                        </option>

                        <!-- <option value="ai_video">
      Generate AI Video
    </option> -->

                      </select>
                    </div>


                    <!-- AI VIDEO IMAGE -->
                    <div *ngIf="
                      reuseForm.get('video_type')?.value === 'ai_video'
                      || aiImagePreview
                    " class="mt-4 flex flex-col items-center gap-3 mb-6">

                      <!-- PREVIEW -->
                      <div class="relative group w-35 h-35">
                        <img [src]="aiImagePreview"
                          class="w-full h-full object-cover rounded-xl border-2 border-gray-200 shadow-lg"
                          draggable="false" />
                      </div>

                      <!-- UPLOAD BUTTON -->
                      <label class="cursor-pointer inline-flex items-center justify-center
                        px-6 py-2.5
                        bg-blue-600 hover:bg-blue-700
                        text-white text-sm font-medium
                        rounded-lg shadow-md
                        transition">
                        🖼 Upload Image for AI Video
                        <input type="file" accept=".png,.jpg" (change)="onAiImageSelected($event)" class="hidden" />
                      </label>

                    </div>

                    <!-- VIDEO FILE -->
                    <div *ngIf="reuseForm.get('video_type')?.value === 'video_upload'" class="mb-6 text-center">

                      <label class="cursor-pointer bg-blue-600 hover:bg-blue-700
                        text-white px-6 py-2.5 rounded-lg shadow-md
                        transition text-sm font-medium inline-block">
                        🎞 Upload MP4 Video
                        <input type="file" accept="video/mp4" (change)="onVideoFileSelected($event)" class="hidden" />
                      </label>

                      <!-- Filename -->
                      <div *ngIf="videoFileName" class="mt-3 text-sm text-gray-600">
                        📄 {{ videoFileName }}
                      </div>
                    </div>


                    <!-- YOUTUBE URL -->
                    <div *ngIf="reuseForm.get('video_type')?.value === 'video_url'" class="mb-6">

                      <label class="block text-sm font-semibold text-gray-700 mb-2">
                        ▶️ Youtube URL
                      </label>

                      <input type="text" formControlName="video_url" placeholder="https://youtube.com/watch?v=..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                          text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          text-sm shadow-sm transition-colors" />
                    </div>

                  </ng-container>
                  <!-- Text Direction -->
                  <div *ngIf="reuseForm.get('tag')?.value" class="mb-6 flex items-center justify-between">
                    <label class="block text-sm font-semibold text-gray-700">🧭 Text Direction</label>

                    <div class="inline-flex rounded-xl border border-gray-200 bg-gray-50 p-1">
                      <button
                        type="button"
                        (click)="$event.preventDefault(); $event.stopPropagation(); setTextDirection('ltr')"
                        [class.bg-white]="textDirection === 'ltr'"
                        [class.shadow]="textDirection === 'ltr'"
                        class="px-4 py-2 rounded-lg text-sm font-semibold text-gray-700 transition"
                      >
                        LTR
                      </button>

                      <button
                        type="button"
                        (click)="$event.preventDefault(); $event.stopPropagation(); setTextDirection('rtl')"
                        [class.bg-white]="textDirection === 'rtl'"
                        [class.shadow]="textDirection === 'rtl'"
                        class="px-4 py-2 rounded-lg text-sm font-semibold text-gray-700 transition"
                      >
                        RTL
                      </button>
                    </div>
                  </div>




                  <ng-container *ngIf="reuseForm.get('tag')?.value !== 'photolink'">
                    <div class="mb-6">
                      <div class="flex items-center justify-between mb-2">
                        <label class="block text-sm font-semibold text-gray-700 flex items-center gap-2">
                          📝 Post Description
                        </label>

                        <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                          Alternative AI Prompt
                        </mat-checkbox>
                      </div>

                      <textarea [attr.dir]="textDirection" formControlName="rss_description" rows="3"
                        placeholder="Enter description..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                             focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                    </div>

                    <div class="mb-6">
                      <label class="block text-sm font-semibold text-gray-700 mb-2">🔗 URL</label>
                      <input [attr.dir]="textDirection" formControlName="rss_article_url" type="text"
                        placeholder="https://..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
                      <div
                        *ngIf="reuseForm.get('rss_article_url')?.invalid && reuseForm.get('rss_article_url')?.touched"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="reuseForm.get('rss_article_url')?.errors?.['pattern']">
                          Enter a valid URL (e.g., https://example.com).
                        </span>
                      </div>
                    </div>

                    <div class="mb-6">
                      <label class="block text-sm font-semibold text-gray-700 mb-2">📌 Caption</label>
                      <textarea [attr.dir]="textDirection" formControlName="post_title" rows="2"
                        placeholder="Enter title..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                    </div>

                    <div class="grid grid-cols-2 mb-6">
                      <div class="pr-2">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">📅 Post Status</label>
                        <select formControlName="post_status"
                          class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                          <option value="" disabled>Select a status</option>
                          <option *ngFor="let s of filteredPostStatuses" [value]="s.value">{{ s.label }}</option>
                        </select>
                        <div *ngIf="reuseForm.get('post_status')?.invalid && reuseForm.get('post_status')?.touched"
                          class="mt-1 text-xs text-red-500">
                          Please select a status.
                        </div>
                      </div>
                      <div class="pl-2">
                        <label class="block text-sm font-semibold text-gray-700 mb-2 w-full sm:w-[177px]">🕒 Schedule Date & Time</label>
                        <input type="datetime-local" formControlName="scheduled_for"
                          [ngStyle]="{'background-color': reuseForm.get('scheduled_for')?.disabled ? '#e5e7eb' : '', 'color': reuseForm.get('scheduled_for')?.disabled ? '#9ca3af' : ''}"
                          class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!-- Right column -->
                <div class="pl-4">
                  <div *ngIf="mediaTags.includes(reuseForm.get('tag')?.value)"
                    class="mb-6 p-8 border-2 border-dashed border-gray-300 rounded-2xl text-center transition-colors cursor-pointer hover:border-blue-500"
                    (drop)="onFilesDropped($event)" (dragover)="onDragOver($event)">
                    <div class="flex flex-col items-center">
                      <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
                      </svg>
                      <p class="mt-4 text-gray-500 font-medium">Drag & Drop your images here</p>
                      <p class="text-sm text-gray-400 mt-1">or click to browse images</p>
                      <input type="file" multiple (change)="onMultipleFilesSelected($event)" class="hidden"
                        #fileInput />
                      <button type="button"
                        class="cursor-pointer mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
                        (click)="fileInput.click()">
                        Select Images
                      </button>
                    </div>
                  </div>

                  <div *ngIf="singleImageTags.includes(reuseForm.get('tag')?.value)" class="mb-6 text-center">
                    <label
                      class="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg shadow-md transition text-sm font-medium">
                      Choose Image
                      <input type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden" />
                    </label>
                  </div>

                  <div *ngIf="imagePreview || uploadedFiles.length > 0" class="mb-6">
                    <button *ngIf="uploadedFiles.length > 1" type="button"
                      class="cursor-pointer mb-3 text-red-600 hover:underline" (click)="clearAll()">Clear All</button>

                    <div *ngIf="imagePreview" class="relative group w-28 h-28 mb-4">
                      <img [src]="imagePreview" draggable="false"
                        class="w-full h-full object-cover rounded-xl shadow-lg border-2 border-gray-200 transition-transform group-hover:scale-105" />
                      <button type="button" (click)="removeImage()"
                        class="cursor-pointer absolute -top-2 -right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-red-700">
                        ✕
                      </button>
                    </div>

                    <div *ngIf="!imagePreview && uploadedFiles.length > 0">
                      <div cdkDropList class="grid grid-cols-3 gap-6 w-full" (cdkDropListDropped)="dropImages($event)">
                        <div *ngFor="let uf of uploadedFiles; let i = index" cdkDrag class="mb-4">
                          <div class="flex flex-col items-center">
                            <div class="relative group w-28 h-28 mb-2">
                              <img [src]="uf.preview" alt="preview"
                                class="w-full h-full object-cover rounded-xl shadow-lg border-2 border-gray-200 transition-transform group-hover:scale-105" />
                              <button type="button" (click)="removeFile(i)"
                                class="cursor-pointer absolute -top-2 -right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-red-700">
                                ✕
                              </button>
                            </div>

                            <div class="alt-input w-full" *ngIf="videoStoryTags.includes(reuseForm.get('tag')?.value)">
                              <label for="alt-text-{{i}}"
                                class="block text-xs font-medium text-gray-700 mb-1">Caption</label>
                              <input id="alt-text-{{i}}" type="text"
                                class="w-full border-gray-300 rounded-lg px-2 py-1 bg-gray-50 text-gray-700 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"
                                [value]="uf.alt" (input)="uploadedFiles[i].alt = $any($event.target).value"
                                placeholder="Enter caption" maxlength="50" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="reuseForm.get('tag')?.value === 'photolink'">
                    <div class="mb-6">
                      <div class="flex items-center justify-between mb-2">
                        <label class="block text-sm font-semibold text-gray-700 flex items-center gap-2">
                          📝 Post Description
                        </label>

                        <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                          Alternative AI Prompt
                        </mat-checkbox>
                      </div>

                      <textarea formControlName="rss_description" rows="3" placeholder="Enter description..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                             focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                    </div>

                    <div class="mb-6">
                      <label class="block text-sm font-semibold text-gray-700 mb-2">🔗 URL</label>
                      <input formControlName="rss_article_url" type="text" placeholder="https://..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
                      <div
                        *ngIf="reuseForm.get('rss_article_url')?.invalid && reuseForm.get('rss_article_url')?.touched"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="reuseForm.get('rss_article_url')?.errors?.['pattern']">
                          Enter a valid URL (e.g., https://example.com).
                        </span>
                      </div>
                    </div>

                    <div class="mb-6">
                      <label class="block text-sm font-semibold text-gray-700 mb-2">📌 Caption</label>
                      <textarea formControlName="post_title" rows="2" placeholder="Enter title..."
                        class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                    </div>

                    <div class="grid grid-cols-2 mb-6">
                      <div class="pr-2">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">📅 Post Status</label>
                        <select formControlName="post_status"
                          class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                          <option value="" disabled>Select a status</option>
                          <option *ngFor="let s of filteredPostStatuses" [value]="s.value">{{ s.label }}</option>
                        </select>
                        <div *ngIf="reuseForm.get('post_status')?.invalid && reuseForm.get('post_status')?.touched"
                          class="mt-1 text-xs text-red-500">
                          Please select a status.
                        </div>
                      </div>

                      <div class="pl-2">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">🕒 Schedule Date & Time</label>
                        <input type="datetime-local" formControlName="scheduled_for"
                          [ngStyle]="{'background-color': reuseForm.get('scheduled_for')?.disabled ? '#e5e7eb' : '', 'color': reuseForm.get('scheduled_for')?.disabled ? '#9ca3af' : ''}"
                          class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="mt-10 flex justify-center gap-4">
                <button type="submit"
                  class="cursor-pointer inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-base font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-blue-600 transition-all transform hover:scale-105">
                  🚀 Submit
                </button>

                <button type="button" (click)="resetForm()" class="cursor-pointer inline-flex items-center gap-2 px-8 py-4
                       bg-gray-200 text-gray-700 text-base font-semibold rounded-xl shadow-sm
                  hover:bg-gray-300 hover:text-gray-900 transition-all transform hover:scale-105">
                  <span>Reset</span>
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SIDEBAR COLUMN -->
<div
  class="hidden md:block col-span-12 2xl:col-span-3 px-3 2xl:px-6 mt-6 2xl:mt-0"
  *ngIf="posts.length > 0 || alerts.length > 0">

  <div class="grid grid-cols-1 gap-5">

    <app-latest-posts
      [posts]="posts"
      [maxSidebarCards]="maxSidebarCards"
      [naPlaceholder]="naPlaceholder"
      (viewPost)="viewRow($event)">
    </app-latest-posts>

    <app-latest-alerts
      [alerts]="alerts"
      [maxSidebarCards]="maxSidebarCards"
      [naPlaceholder]="naPlaceholder"
      (viewAlert)="viewAlert($event)">
    </app-latest-alerts>

  </div>

</div>

</div>
